import view from "../../../Enums";
import { makeStyle } from "../../../utils";
import { rowCenter } from "../../../resources/styles";

const styles = {};

styles['container'] = makeStyle({
    backgroundColor: 'white',
    width: '100%', minHeight: 60,
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    zIndex: 10,
});

styles['actions'] = makeStyle([rowCenter, { justifyContent: 'flex-end', fontWeight: 600 }], {}, {}, { marginRight: 4 });

styles['action'] = makeStyle({ margin: '4px 16px', fontSize: 14, display: 'flex' }, {}, {}, { margin: '4px 8px' });

styles['action_icon'] = makeStyle({}, {}, {}, { border: '1px solid', borderRadius: '50%', padding: 8, });

styles['action_text'] = makeStyle({ marginLeft: 4 }, {}, {}, { display: 'none' });


styles['oyo_logo'] = makeStyle({ alignSelf: 'center' }, { padding: 16 }, view.DESKTOP, { padding: 12 });


styles['back_link_arrow'] = makeStyle({ height: 18, width: 18 });


export default styles;